import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, ModalResult, DeleteSelfOrganizationMemberModalComponent as ModalComponent } from './delete-self-organization-member-modal.component';

@Injectable({ providedIn: 'root' })
export class DeleteSelfOrganizationMemberModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
